import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useFormContext } from 'react-hook-form'

import { openFoiBillInNewWindow } from '../../util/openInNewWindow'
import { attachmentStatuses } from '../../util/attachmentConsts'
import { FlexRow, SpaceBetweenRowContainer } from '../styles/Containers'
import { SelectMenuItem } from '../styles/TextField'
import FormSelect from '../inputFields/FormSelect'
import OpenInNewTabButton from '../common/OpenInNewTabButton'
import AttachmentStatus from '../foiAttachments/AttachmentStatus'

const OptionContainer = styled(SpaceBetweenRowContainer)`
  width: 100%;
`

function SelectBillForm({ foiId, bills = [], label = '', disabled = false, required = false }) {
  const { watch } = useFormContext()

  const billId = watch('billId')

  return (
    <SpaceBetweenRowContainer gap="10px">
      <>
        <FormSelect
          key={billId}
          required={required}
          id="billId"
          label={label}
          options={bills}
          defaultValue={billId || ''}
          disabled={disabled}
          basis="100%"
          minwidth="0">
          <SelectMenuItem value="">None</SelectMenuItem>
          {bills.map(b => (
            <SelectMenuItem key={b.id} value={b.id} component="div">
              <OptionContainer>
                {b.name}
                {b.status && <AttachmentStatus status={b.status} style="small" />}
              </OptionContainer>
            </SelectMenuItem>
          ))}
        </FormSelect>
        <FlexRow padding={label ? '27px 0 0' : '0'}>
          <OpenInNewTabButton label="View bill in new tab" onClick={() => openFoiBillInNewWindow(foiId, billId)} disabled={disabled} />
        </FlexRow>
      </>
    </SpaceBetweenRowContainer>
  )
}

SelectBillForm.propTypes = {
  foiId: PropTypes.string.isRequired,
  label: PropTypes.string,
  bills: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.oneOf(attachmentStatuses)
    })
  ),
  disabled: PropTypes.bool,
  required: PropTypes.bool
}

export default SelectBillForm
